import React from 'react'
import { Box, Typography } from '@mui/material'
import ScratchCardTable from './Table'
import Toolbar from './Toolbar'

const ScratchCard = () => (
  <Box textAlign='center' boxShadow={1} style={{ color: '#464646', background: 'whitesmoke' }}>
    <Box pt={6} pb={4}>
      <Typography variant='h2' gutterBottom={true}>
        End User
      </Typography>
      <Typography variant='h1' fontWeight={900} fontSize={36}>
        Win a GWM
      </Typography>
    </Box>
    {/* Action toolbar */}
    <Toolbar></Toolbar>
    <ScratchCardTable></ScratchCardTable>
  </Box>
)

export default ScratchCard
